import { useCallback, useRef } from 'react';

import { useEvent } from '~features/events/hooks/useEvent';
import { RenderProofAnalyticsEventProperties } from './RenderProofAnalyticsEvents';

type TrackRenderProofEvent = <
  E extends keyof RenderProofAnalyticsEventProperties,
>(
  event: E,
  properties: RenderProofAnalyticsEventProperties[E],
) => void;

export function useTrackRenderProofEvent(): TrackRenderProofEvent {
  const { track } = useEvent();
  // useEvent().track is unstable (new ref every render). useRef keeps the
  // callback identity stable so consumers can list it as an effect dependency.
  const trackRef = useRef(track);
  trackRef.current = track;

  return useCallback<TrackRenderProofEvent>((event, properties) => {
    trackRef.current(event, properties);
  }, []);
}
